<template>
  <section id="generate" ref="generateContent">
    <PageTitle :title="$t('amazon.generate.title')" :breadcrumbs="breadcrumbs"></PageTitle>
    
    <div class="wrapper wrapper-content animated fadeInRight">

      <Header></Header>

      <div class="row" v-if="selectedModule">
        <div class="col">
          <Generate></Generate>
        </div>
      </div>

    </div>
  </section>
</template>


<script lang="ts">
import { Ref, defineComponent, PropType, computed, onMounted, onBeforeUnmount, ref, watch, reactive, ComputedRef } from '@fwk-node-modules/vue'
import { getApp, useRouter, useStore } from '@fwk-client/utils/vue-3-migration';

import { enableIbox, disableIbox} from '@root/src/client/theme/inspinia-jquery'; 

import { useGenericPage } from '@fwk-client/composables/useGenericPage';

import PageTitle from '@root/src/client/components/panels/PageTitle.vue';
import Header from '../panels/Header.vue';
import Generate from '../panels/Generate.vue';

import { useModuleAdmin } from '../../composables/useModuleAdmin';

export default defineComponent({
  props: {
  },
  components: {
    PageTitle,
    Generate,
    Header
  },
  setup(props, context) {
    const app = getApp();
    const $router = useRouter();
    const $store = useStore();

    const genericPage = useGenericPage(props, context);
    const { modules, selectedModule } = useModuleAdmin(props, context);

    const generateContent:Ref<HTMLElement|null> = ref(null);

    const breadcrumbs = [{
      label: app.$t('home.dashboard')
    },
    {
      label: app.$t('amazon.title')
    }]
    
    onMounted(() => {
      enableIbox(generateContent.value!);
    })

    onBeforeUnmount(() => {
      disableIbox(generateContent.value!);
    })

    return {
      generateContent,
      breadcrumbs,
      selectedModule
    }
  }
});
</script>